/**
 * Copyright (c) Microsoft. All rights reserved.
 */

/**
 * Enum with the possible options for sorting in the distribution chart.
 */
export enum SortOptions {
    none = 'none',
    correct = 'correct',
    unclear = 'unclear',
    incorrect = 'incorrect',
    intentName = 'intentName',
    allUtterances = 'utterancesNumber'
}
